import { ChangeEvent } from "react";

import { TableFilterProps } from "./TableFilter.types";
import styles from "./TableFilter.module.scss";

export const TextFilterComponent: React.FC<TableFilterProps> = ({ value, onChange }) => (
  <div className={styles.textFilter}>
    <input
      className={`${styles.control} ${styles.textFilterInput}`}
      type="text"
      value={typeof value === "string" ? value : ""}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
      aria-label="Filter text"
    />
    {typeof value === "string" && value !== "" && (
      <button
        className={styles.textFilterClear}
        type="button"
        aria-label="Clear text filter"
        onClick={() => onChange(undefined)}
      >
        ×
      </button>
    )}
  </div>
);